$ const { minValue, maxValue, entries, showMinError, showMaxError } = input;
$ const entryMin = entries?.find((entry) => entry.fieldId === "MIN");
$ const entryMax = entries?.find((entry) => entry.fieldId === "MAX");
$ const validationMessage = entryMax?.validations?.[0]?.message?.title;

<div class="filter-price-dialog__header">
  <div class="filter-price-dialog__header-input">
    <if(entryMin)>
      <ebay-textbox
        data-testid="filter-price-options-min"
        fluid
        type="text"
        value=minValue
        placeholder=""
        on-input-change("handleMinPriceChange")
        invalid=showMinError
      >
        <@prefix-text>
          <fe-textual-display model=entryMin.secondaryLabel/>
        </@prefix-text>
      </ebay-textbox>
      <p class="filter-price-dialog__header-hint">
        <fe-textual-display model=entryMin.label/>
      </p>
    </if>
  </div>
  <div class="filter-price-dialog__header-input">
    <if(entryMax)>
      <ebay-textbox
        data-testid="filter-price-options-max"
        fluid
        type="text"
        value=maxValue
        placeholder=""
        on-input-change("handleMaxPriceChange")
        invalid=showMaxError
      >
        <@prefix-text>
          <fe-textual-display model=entryMax.secondaryLabel/>
        </@prefix-text>
      </ebay-textbox>
      <p class="filter-price-dialog__header-hint">
        <fe-textual-display model=entryMax.label/>
      </p>
    </if>
  </div>
</div>
<if((showMaxError || showMinError) && validationMessage)>
  <div class="filter-price-dialog__header-input__error" data-testid="filter-price-options-max-error">
    <ebay-inline-notice status="attention">
      <fe-textual-display model=validationMessage/>
    </ebay-inline-notice>
  </div>
</if>
